jQuery(function($)
{
    var
        $body = $('body');

    function handleReferenceMouseenter()
    {
        var $target = $('#' + $(this).data('reference-target'));

        $($target).addClass('active');
    }

    function handleReferenceMouseleave()
    {
        var $target = $('#' + $(this).data('reference-target'));

        $($target).removeClass('active');
    }

    $body
        .on('mouseenter', '.js-reference', handleReferenceMouseenter)
        .on('mouseleave', '.js-reference', handleReferenceMouseleave);
});
